import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { ChevronDown } from '../../icons/arrows/ChevronDown';
import { ChevronUp } from '../../icons/arrows/ChevronUp';
import { IconButton } from '../IconButton';
import styles from './Carousel.module.scss';
export const CarouselHeader = (param)=>{
    let { collapsible, isCollapsed, header, headerTestId, toggleTestId, expandAriaLabel, collapseAriaLabel, onToggle } = param;
    if (!collapsible && header == null) return null;
    const isTappable = collapsible && isCollapsed;
    const handleHeaderClick = (event)=>{
        if (!isTappable) return;
        if (event.target.closest('button, a, input, select, textarea') != null) return;
        onToggle();
    };
    const handleHeaderKeyDown = (event)=>{
        if (!isTappable) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        onToggle();
    };
    const handleChevronClick = (event)=>{
        event.stopPropagation();
        onToggle();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.header, {
            [styles.tappable]: isTappable
        }),
        "data-testid": headerTestId,
        onClick: isTappable ? handleHeaderClick : undefined,
        onKeyDown: isTappable ? handleHeaderKeyDown : undefined,
        role: isTappable ? 'button' : undefined,
        tabIndex: isTappable ? 0 : undefined,
        children: [
            header != null && /*#__PURE__*/ _jsx("div", {
                className: styles.headerContent,
                children: header
            }),
            collapsible && /*#__PURE__*/ _jsx(IconButton, {
                // eslint-disable-next-line custom/no-hardcoded-bi-name-in-seagull -- WHY: CarouselHeader owns the inherent fixed-semantic collapse/expand toggle; consumers cannot rename it (rule 6a), so the name is hardcoded by design, not a missing pass-through.
                bi: {
                    name: 'toggle_collapse'
                },
                className: cn({
                    [styles.chevron]: header == null
                }),
                size: "xsmall",
                skin: "transparent",
                noPadding: true,
                "aria-label": isCollapsed ? expandAriaLabel : collapseAriaLabel,
                onClick: handleChevronClick,
                testId: toggleTestId,
                children: isCollapsed ? /*#__PURE__*/ _jsx(ChevronDown, {
                    size: 16
                }) : /*#__PURE__*/ _jsx(ChevronUp, {
                    size: 16
                })
            })
        ]
    });
};
